export default __webpack_public_path__ + "static/media/mark-circle.b06752ba.svg";